export const HYATT_AUTH_REDIRECT_URL =
  'https://www.hyattexperiences.com/oauth-redirect';
export const HYATT_ACCESS_TOKEN_SESSION_KEY = 'hyattAccessToken';
export const HYATT_ACCESS_TOKEN_EXPIRY_TIME_SESSION_KEY =
  'hyattAccessTokenExpiryTime';
export const HYATT_REDIRECT_ON_LOGIN_LOCAL_KEY =
  'savedRedirectUrlAfterLogInSuccess'; // updating this key requires you to also update code on webflow for this page https://www.hyattexperiences.com/oauth-redirect
export const HYATT_DEV_ORG_ID = 'ae1aa9a5-7862-4830-a996-4ae890ae3721';
export const HYATT_STG_ORG_ID = '4d120170-cc6f-4341-9397-146d962fbe30';
export const HYATT_TEST_ORG_ID = '3617556c-cf6d-4b65-945a-5f349da3d68a';
export const HYATT_PROD_ORG_ID = '3617556c-cf6d-4b65-945a-5f349da3d68a';
